import styled from 'styled-components';
import PropTypes from 'prop-types';

const RadioButton = ({ text, value, selected, onChange }) => {
  const handleClick = () => onChange(value);

  return (
    <RadioButtonContainer onClick={handleClick}>
      <RadioButtonOuterCircle selected={selected === value}>
        <RadioButtonInnerCircle selected={selected === value} />
      </RadioButtonOuterCircle>
      {text}
    </RadioButtonContainer>
  );
};

RadioButton.propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default RadioButton;

const RadioButtonContainer = styled.div`
  flex: ${props => (props.theme.radioButton.align === 'stretch' ? '1' : '0')};
  display: flex;
  gap: ${props => props.theme.radioButton.gap};
  align-items: center;
  background-color: ${props => props.theme.radioButton.wrapperBackgroundColor};
  border-radius: ${props => props.theme.radioButton.borderRadius};
  padding: ${props => props.theme.radioButton.padding};
  cursor: pointer;
  user-select: none;
  font-family: ${props => props.theme.baseFont.fontFamily};
  font-weight: ${props => props.theme.baseFont.fontWeight};
  font-size: ${props => props.theme.radioButton.fontSize};
  color: ${props => props.theme.input.fontColor};
  line-height: 1;
`;

const RadioButtonInnerCircle = styled.div`
  width: ${props =>
    props.selected
      ? props.theme.radioButton.selected.innerCircleBackgroundDiameter
      : props.theme.radioButton.innerCircleBackgroundDiameter};
  height: ${props =>
    props.selected
      ? props.theme.radioButton.selected.innerCircleBackgroundDiameter
      : props.theme.radioButton.innerCircleBackgroundDiameter};
  border-radius: 50%;
  background-color: ${props =>
    props.selected
      ? props.theme.radioButton.selected.innerCircleBackgroundColor
      : props.theme.radioButton.innerCircleBackgroundColor};
`;

const RadioButtonOuterCircle = styled.div`
  width: ${props => props.theme.radioButton.outerCircleDiameter ?? '1rem'};
  height: ${props => props.theme.radioButton.outerCircleDiameter ?? '1rem'};
  min-width: ${props => props.theme.radioButton.outerCircleDiameter ?? '1rem'};
  min-height: ${props => props.theme.radioButton.outerCircleDiameter ?? '1rem'};
  border: ${props =>
    props.selected
      ? props.theme.radioButton.selected.outerCircleBorder
      : props.theme.radioButton.outerCircleBorder};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.2rem;
`;
